var map = {
	"./brasil_1.jpg": "05a1",
	"./kappverde_1.jpg": "37fd",
	"./lapper/steder_lapper_Kapp-Verde.png": "0923",
	"./lapper/steder_lapper_Sauda.png": "4c0b",
	"./lapper/steder_lapper_recife.png": "062b",
	"./sauda.jpg": "f190"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0305";